// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Instruction_statsSection__tzJR7 {
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  /* padding: 50px 0; */
}
.Instruction_content__TgLSk {
  margin-left: 2rem;
}

.Instruction_imageContainer__MWYtC {
  flex: 1 1;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.Instruction_mobileImage__4yvuI {
  width: 150px;
  height: auto;
}

.Instruction_textContent__vnHAb {
  flex: 1 1;
  padding: 20px;
  font-family: Poppins;
}
.Instruction_subHeading__1Ymay {
  font-family: Poppins;
  font-weight: 600;
  font-size: 36px;
}
.Instruction_highlight__R58c8 {
  color: #ff6500;
}
.Instruction_paragraph__oV3Qm {
  color: #667085;
  font-family: Poppins;
  font-size: 16px;
}
.Instruction_statNumber__1ywRQ {
  font-family: Poppins;
  font-size: 50px;
  font-weight: 600;
  text-align: start;
  color: #ff6500;
}
.Instruction_statText__cMOxL {
  color: #667085;
  font-family: Poppins;
  font-size: 16px;
  text-align: start;
}
.Instruction_heading__rFtig {
  color: #ff6500;
  font-family: Poppins;
}
@media (min-width: 300px) and (max-width: 400px) {
  .Instruction_content__TgLSk {
    margin-top: 2rem;
    margin-left: 1rem;
    /* width: 6000px; */
    /* background-color: black; */
  }
  .Instruction_heading__rFtig{
    margin-top: 12px;
  }
  .Instruction_imgDiv__oW0P9 {
    margin-left: 15px;
  }
  .Instruction_container__mubIo {
    width: 365px;
    /* background-color: black; */
  }
  .Instruction_hideOnSmall__AzYRX {
    display: none;
  }
}
@media (min-width: 400px) and (max-width: 600px) {
  .Instruction_content__TgLSk {
    margin-top: 2rem;
    margin-left: 1rem;
    /* width: 6000px; */
    /* background-color: black; */
  }
  .Instruction_heading__rFtig{
    margin-top: 12px;
  }
  .Instruction_imgDiv__oW0P9 {
    margin-left: 26px;
  }
  .Instruction_container__mubIo {
    width: 410px;
    /* background-color: black; */
  }
  .Instruction_hideOnSmall__AzYRX {
    display: none;
  }
}
@media (min-width: 600px) and (max-width: 1024px) {
  .Instruction_content__TgLSk {
    margin-top: 2rem;
    /* margin-left: 20px */
    /* width: 6000px; */
    /* background-color: black; */
  }
  .Instruction_imgDiv__oW0P9 {
    padding-left: 0rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Instruction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".statsSection {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3rem;\n  /* padding: 50px 0; */\n}\n.content {\n  margin-left: 2rem;\n}\n\n.imageContainer {\n  flex: 1;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.mobileImage {\n  width: 150px;\n  height: auto;\n}\n\n.textContent {\n  flex: 1;\n  padding: 20px;\n  font-family: Poppins;\n}\n.subHeading {\n  font-family: Poppins;\n  font-weight: 600;\n  font-size: 36px;\n}\n.highlight {\n  color: #ff6500;\n}\n.paragraph {\n  color: #667085;\n  font-family: Poppins;\n  font-size: 16px;\n}\n.statNumber {\n  font-family: Poppins;\n  font-size: 50px;\n  font-weight: 600;\n  text-align: start;\n  color: #ff6500;\n}\n.statText {\n  color: #667085;\n  font-family: Poppins;\n  font-size: 16px;\n  text-align: start;\n}\n.heading {\n  color: #ff6500;\n  font-family: Poppins;\n}\n@media (min-width: 300px) and (max-width: 400px) {\n  .content {\n    margin-top: 2rem;\n    margin-left: 1rem;\n    /* width: 6000px; */\n    /* background-color: black; */\n  }\n  .heading{\n    margin-top: 12px;\n  }\n  .imgDiv {\n    margin-left: 15px;\n  }\n  .container {\n    width: 365px;\n    /* background-color: black; */\n  }\n  .hideOnSmall {\n    display: none;\n  }\n}\n@media (min-width: 400px) and (max-width: 600px) {\n  .content {\n    margin-top: 2rem;\n    margin-left: 1rem;\n    /* width: 6000px; */\n    /* background-color: black; */\n  }\n  .heading{\n    margin-top: 12px;\n  }\n  .imgDiv {\n    margin-left: 26px;\n  }\n  .container {\n    width: 410px;\n    /* background-color: black; */\n  }\n  .hideOnSmall {\n    display: none;\n  }\n}\n@media (min-width: 600px) and (max-width: 1024px) {\n  .content {\n    margin-top: 2rem;\n    /* margin-left: 20px */\n    /* width: 6000px; */\n    /* background-color: black; */\n  }\n  .imgDiv {\n    padding-left: 0rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsSection": `Instruction_statsSection__tzJR7`,
	"content": `Instruction_content__TgLSk`,
	"imageContainer": `Instruction_imageContainer__MWYtC`,
	"mobileImage": `Instruction_mobileImage__4yvuI`,
	"textContent": `Instruction_textContent__vnHAb`,
	"subHeading": `Instruction_subHeading__1Ymay`,
	"highlight": `Instruction_highlight__R58c8`,
	"paragraph": `Instruction_paragraph__oV3Qm`,
	"statNumber": `Instruction_statNumber__1ywRQ`,
	"statText": `Instruction_statText__cMOxL`,
	"heading": `Instruction_heading__rFtig`,
	"imgDiv": `Instruction_imgDiv__oW0P9`,
	"container": `Instruction_container__mubIo`,
	"hideOnSmall": `Instruction_hideOnSmall__AzYRX`
};
export default ___CSS_LOADER_EXPORT___;
